import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { CalendarDays, CalendarFold, CalendarX2, X } from "lucide-react";
import server from "../../../server";
import Locale from "../../../core/locale/locale";
import { getShortDay } from "../../../utility/utility";
import { Holiday } from "../../../domains/models/holiday";
import { useNavigate } from 'react-router-dom';
import EmptyData from "../../common/empty-data/empty-data";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

const HolidayCard = () => {
    const [holidays, setHolidays] = useState<Holiday[]>([]);
    const currentYear = new Date().getFullYear();
    const todayDate = new Date();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const sortHolidays = (holidays: Holiday[]) => {
        return holidays.sort((a, b) => {
            const startA = dayjs(a.date);
            const startB = dayjs(b.date);

            if (startA.isBefore(startB)) {
                return -1;
            } else if (startA.isAfter(startB)) {
                return 1;
            } else {
                return 0;
            }
        });
    };

    async function fetchHolidays() {
        setLoading(true);
        try {
            const holidayList = await server.holiday.list(currentYear);
            const filteredHolidayList = holidayList.filter((holiday: any) => new Date(holiday.date) > todayDate);
            const formattedHolidays = sortHolidays(filteredHolidayList);

            setHolidays(formattedHolidays);
        } catch (e) {
            console.log("Error while fetching holidays", e);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchHolidays();
    }, [])

    const handleOnClick = () => {
        navigate('/time-off/holidays');
    }

    return (
        <div onClick={handleOnClick} className={'dashboard-card dashboard-holiday-card'}>
            <div className={'dashboard-card__header'}>
                <span className={'dashboard-card__icon-wrapper dashboard-holiday-card__icon-wrapper'}>
                    <CalendarDays className={'dashboard-card__icon dashboard-holiday-card__icon'}/>
                </span>

                <h5 className={'dashboard-card__title'}>
                    Upcoming Holidays
                    <p className={'dashboard-card__description'}>Next 3 months at a glance.</p>
                </h5>
                <span className={'dashboard-holiday-card__holiday-count'}>{holidays.length}{' '}Holidays</span>

            </div>

            <LoadingSkeleton loading={loading}>
                <div className={"dashboard-holiday-card__content"}>
                    {holidays.length > 0 ? <ul className={"dashboard-holiday-card__list"}>
                            {    //render first 4 holidays
                                holidays.slice(0, 5)?.map((item: Holiday) => (
                                    <li className={"dashboard-holiday-card__list-item"} key={item.id}>
                                        <div className={'list-name'}>
                                            <span> {item.name}</span>
                                        </div>
                                        <div className={"date-day"}>
                                            <span>{item?.date ? dayjs(item.date).format(Locale.displayDateAndMonth) : "-"}</span>
                                            <span>{getShortDay(item.day)}</span>
                                        </div>
                                    </li>
                                ))
                            }
                        </ul> :
                        <EmptyData
                            icon={<CalendarFold className={'holiday-empty-data-icon'}/>}
                            title={"No upcoming holidays for this year!"}
                            subtitle={"There are currently no upcoming holidays scheduled for this period."}
                        />
                    }
                </div>
            </LoadingSkeleton>

        </div>
    )
}

export default HolidayCard;
